import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, Subscription } from 'rxjs';
import { EntityFileModel } from 'src/app/core/models/file/entity-file-model';
import { FileRequestModel } from 'src/app/core/models/file/file-request-model';
import { HighlightColorModel } from 'src/app/core/models/file/highlight-values-model';
import { OCRCreateColorHighlightedKeywordFileRequestModel } from 'src/app/core/models/file/ocr-create-color-highlighted-keyword-file-request-model';
import { AiApiService } from 'src/app/core/services/ai-api.service';

@Component({
  selector: 'app-search-keywords-modal',
  templateUrl: './search-keywords-modal.component.html',
  styleUrls: ['./search-keywords-modal.component.scss']
})
export class SearchKeywordsModalComponent {

  @Input() public entityName?: string;
  @Input() public sourceOCREntityFileRequest!: FileRequestModel;
  @Input() public targetEntityFileUpload!: EntityFileModel;

  spinnerIsShown: boolean = false;

  ocrHighlightModel: OCRCreateColorHighlightedKeywordFileRequestModel = new OCRCreateColorHighlightedKeywordFileRequestModel;

  keywordSearch: { searchTerms: string[], hexCode: string }[] = [
    { searchTerms: [], hexCode: "#85c1e9" },
    { searchTerms: [], hexCode: "#f8c471" },
    { searchTerms: [], hexCode: "#7dcea0" },
    { searchTerms: [], hexCode: "#f1948a" },
    { searchTerms: [], hexCode: "#c39bd3" }
  ];

  minLengthTerm: number = 1;
  searchTerm: string | undefined;
  searchTerm$ = new Subject<string>();

  constructor(
    private modalRef: NgbActiveModal,
    private aiApiService: AiApiService
  ) {
  }

  ngOnInit(): void {
    this.ocrHighlightModel.targetEntityFileUpload = this.targetEntityFileUpload;
    this.ocrHighlightModel.sourceOCREntityFileRequest = this.sourceOCREntityFileRequest;
    this.searchTerm$.subscribe(search => {
      if (search != undefined) {
        this.searchTerm = search;
      }
    });

  }

  addCustomTag(tag: any) {
    return tag;
  }

  create() {
    this.keywordSearch.forEach(row => {
      if (row.searchTerms && row.searchTerms[0] !== undefined) {
        var colorModel: HighlightColorModel = this.hexToHighlightColorModel(row.hexCode);
        row.searchTerms.forEach((term: string) => {
          this.ocrHighlightModel.keywords = { ...this.ocrHighlightModel.keywords, ...{ [term]: colorModel } }
        })
      }
    });

    var sub: Subscription = this.aiApiService.createColorHighlightedSearchTermsPDF(this.ocrHighlightModel).subscribe((result) => {
      this.close();
      sub.unsubscribe();
    })

  }

  hexToHighlightColorModel(hex: string): HighlightColorModel {
    var highLightColor: HighlightColorModel = new HighlightColorModel;

    let parseString = hex;

    if (hex.startsWith('#')) { parseString = hex.slice(1, 7); }

    highLightColor.red = parseInt(parseString.slice(0, 2), 16);
    highLightColor.green = parseInt(parseString.slice(2, 4), 16);
    highLightColor.blue = parseInt(parseString.slice(4, 6), 16);

    return highLightColor;
  }

  close() {
    this.modalRef.close();
  }
  dismiss() {
    this.modalRef.dismiss();
  }
}
